import './OrganizationDetails.scss';
import PaymentMethods from '../form/PaymentMethods';
import { usePaymentMethodsContext } from '../../../hooks/usePaymentMethods';
import ManualCaptureMessage from '../content/ManualCaptureMessage';
import CardOnsiteMessage from '../content/CardOnsiteMessage';

const { Button, CardSection, MessageBox } = require('@paymongo/seeds');

interface isOrganization {
  app: string;
  tradeName: string;
  setShowForm: Function;
}

const OrganizationDetails = ({
  app,
  tradeName,
  setShowForm,
}: isOrganization) => {
  const paymentMethodContext = usePaymentMethodsContext();

  const redirectToShopify =  () => {
    const appSettingsUrl: string = new URLSearchParams(document.location.search).get('app_settings_url') || '';
    window.location.href = appSettingsUrl;
  };

  const paymentSection: Record<isOrganization['app'], JSX.Element> = {
    default: <PaymentMethods />,
    card: <ManualCaptureMessage />,
    card_onsite: <CardOnsiteMessage />,
  };

  return (
    <CardSection className="organization-details">
      <div className="organization-details__header --mb-md">
        <h2>PayMongo Shopify Settings</h2>

        <Button type="default" className="text --bold" onClick={ redirectToShopify }>
          Back to Shopify
        </Button>
      </div>

      <div className="organization-details__success-message --pb-lg">
        <MessageBox>
          {
            paymentMethodContext.isSuccess ?
            "Your active payment methods have been updated.":
            "Your PayMongo account is now connected to your Shopify store!"
          }
        </MessageBox>
      </div>

      <div className="organization-details__container">
        <div className="organization-details__name">
          <h5 className='--mt-0 --mb-xs'>Connected Account</h5>
          <span>{ tradeName }</span>
        </div>

        <Button className="text organization-details__change-button --bold" onClick={ setShowForm } >
          Change
        </Button>
      </div>

      {paymentSection[app] || <></>}
    </CardSection>
  );
}

export default OrganizationDetails;
